import React from "react";

const Contato = () => {
  return (
    <div className="w-full bg-white dark:bg-white h-fit p-5 flex flex-col items-center justify-center">
      <h1 className="text-5xl text-[#292b53]">
        Ficou com alguma dúvida?
      </h1>
      <button className="w-[240px] h-[50px] border border-[rgb(97,198,44)] rounded-xl border-3 mx-auto text-xl m-10
        hover:text-black hover:bg-[rgb(97,198,44)]  hover:scale-110 duration-150">
        <a 
          href="https://api.whatsapp.com/send/?phone=5541992636949&text=Ol%C3%A1%21+Vim+do+Google+e+gostaria+de+tirar+d%C3%BAvidas.&type=phone_number&app_absent=0"
          onClick={(e) => {
            e.preventDefault();
            window.gtag_report_conversion("https://api.whatsapp.com/send/?phone=5541992636949&text=Ol%C3%A1%21+Vim+do+Google+e+gostaria+de+tirar+d%C3%BAvidas.&type=phone_number&app_absent=0");
          }}
        >
          Whatsapp
        </a>
      </button>

      <h1 className="text-2xl font-light m-1"><strong>Endereço:</strong> R. Teixeira Soares, 138 - loja 2 - Seminário, Curitiba - PR, 80240-440</h1>
      <h1 className="text-2xl font-light m-1"><strong>Telefone:</strong> (41) 99263-6949</h1>
      <h1 className="text-2xl font-light m-1"><strong>Horários de funcionamento:</strong></h1>
      <ul className="flex flex-col text-xl">
        <div className="divide-y-2 divide-white-80">
          <div className="flex justify-between items-start">
            <li className="mr-2 w-full">Segunda-Feira</li>
            <li className="ml-2 w-full">08:00-18:00</li>
          </div>
          <div className="flex justify-center">
            <li className="mr-2 w-full">Terça-Feira</li>
            <li className="ml-2 w-full">08:00-18:00</li>
          </div>
          <div className="flex justify-center">
            <li className="mr-2 w-full">Quarta-Feira</li>
            <li className="ml-2 w-full">08:00-18:00</li>
          </div>
          <div className="flex justify-center">
            <li className="mr-2 w-full">Quinta-Feira</li>
            <li className="ml-2 w-full">08:00-18:00</li>
          </div>
          <div className="flex justify-center">
            <li className="mr-2 w-full">Sexta-Feira</li>
            <li className="ml-2 w-full">08:00-18:00</li>
          </div>
          <div className="flex justify-center">
            <li className="mr-2 w-full">Sábado</li>
            <li className="ml-2 w-full">08:00-12:00</li>
          </div>
          <div className="flex justify-center">
            <li className="mr-2 w-full">Domingo</li>
            <li className="ml-2 w-full">Fechado</li>
          </div>
        </div>
        
      </ul>
      
    </div>
  )
}

export default Contato;
